import React from 'react';
import {connect} from 'react-redux';
import {Route, Switch, withRouter} from 'react-router-dom';
import {push} from 'react-router-redux';
import {bindActionCreators} from 'redux';

import {clearAlert, clearState} from 'Skelet/src/modules/fetch.action';
import AlertBar from 'Skelet/src/components/AlertBar';
import Start from './Start';
import Reviews from './Reviews';
import LeadMagnets from './LeadMagnets';
import Services from './Services';
import ServicesPosts from './ServicesPosts';
import ServicesArticles from './ServicesArticles';
import OneOff from './OneOff';
import Portfolio from './Portfolio';
import Contact from './Contact';
import LetterGenerator from './LetterGenerator';
import LetterGeneratorCTO from './LetterGeneratorCTO';
import PageGenerator from './PageGenerator';
import PageGeneratorCTO from './PageGeneratorCTO';

import Articles from './Articles.js';
import Article1 from './articles/Article1.js';
import Article2 from './articles/Article2.js';
import Article3 from './articles/Article3.js';
import Article4 from './articles/Article4.js';

import LetterLandingExample from './letterfunnel/landings/_example.js';
import LetterLandingExampleCTO from './letterfunnel/landings/_exampleCTO.js';

import jeffreyhamelink from './letterfunnel/landings/jeffreyhamelink.js';
import peterharmschalk from './letterfunnel/landings/peterharmschalk.js';
import dennisnieuwenhuys from './letterfunnel/landings/dennisnieuwenhuys.js';
import peterpauldevries from './letterfunnel/landings/peterpauldevries.js';
import wanglongli from './letterfunnel/landings/wanglongli.js';
import paulbuyse from './letterfunnel/landings/paulbuyse.js';
import ralphbrasker from './letterfunnel/landings/ralphbrasker.js';
import leanschieving from './letterfunnel/landings/leanschieving.js';
import marielschaab from './letterfunnel/landings/marielschaab.js';
import albertkuiper from './letterfunnel/landings/albertkuiper.js';
import bertholdbakker from './letterfunnel/landings/bertholdbakker.js';
import laurensvanmierlo from './letterfunnel/landings/laurensvanmierlo.js';
import marcodeboer from './letterfunnel/landings/marcodeboer.js';
import ericschouten from './letterfunnel/landings/ericschouten.js';
import mariekevaniperen from './letterfunnel/landings/mariekevaniperen.js';
import gerritjanreinders from './letterfunnel/landings/gerritjanreinders.js';
import robinschuil from './letterfunnel/landings/robinschuil.js';
import tomkamperman from './letterfunnel/landings/tomkamperman.js';
import joachimdelooij from './letterfunnel/landings/joachimdelooij.js';
import arnoknoops from './letterfunnel/landings/arnoknoops.js';
import laurensgroen from './letterfunnel/landings/laurensgroen.js';
import renaldomelkert from './letterfunnel/landings/renaldomelkert.js';
import joachimbeckmann from './letterfunnel/landings/joachimbeckmann.js';
import tonychung from './letterfunnel/landings/tonychung.js';
import joslazet from './letterfunnel/landings/joslazet.js';
import ashokmarla from './letterfunnel/landings/ashokmarla.js';
import jaapdebruijn from './letterfunnel/landings/jaapdebruijn.js';
import jochananbax from './letterfunnel/landings/jochananbax.js';
import markvanwerven from './letterfunnel/landings/markvanwerven.js';
import brunopellicci from './letterfunnel/landings/brunopellicci.js';
import janjaapvandenhoek from './letterfunnel/landings/janjaapvandenhoek.js';
import remcotreuren from './letterfunnel/landings/remcotreuren.js';
import dirkhuibers from './letterfunnel/landings/dirkhuibers.js';
import gijsopdeweegh from './letterfunnel/landings/gijsopdeweegh.js';
import wannepemmelaar from './letterfunnel/landings/wannepemmelaar.js';
import nickblom from './letterfunnel/landings/nickblom.js';
import meesvanvelzen from './letterfunnel/landings/meesvanvelzen.js';
import koenlavrijssen from './letterfunnel/landings/koenlavrijssen.js';
import rubenwieman from './letterfunnel/landings/rubenwieman.js';
import nickhillebrand from './letterfunnel/landings/nickhillebrand.js';
import janwillemseeder from './letterfunnel/landings/janwillemseeder.js';
import edwinvlieg from './letterfunnel/landings/edwinvlieg.js';
import fionagu from './letterfunnel/landings/fionagu.js';
import bobsalm from './letterfunnel/landings/bobsalm.js';
import johankenzeler from './letterfunnel/landings/johankenzeler.js';
import christopherhoffman from './letterfunnel/landings/christopherhoffman.js';
import otmannouinou from './letterfunnel/landings/otmannouinou.js';
import eduardanghel from './letterfunnel/landings/eduardanghel.js';
import ankievanwersch from './letterfunnel/landings/ankievanwersch.js';
import rupeshkumar from './letterfunnel/landings/rupeshkumar.js';
import jennifergoodall from './letterfunnel/landings/jennifergoodall.js';
import susantmallick from './letterfunnel/landings/susantmallick.js';
import robvandenhoogen from './letterfunnel/landings/robvandenhoogen.js';
import jasparroos from './letterfunnel/landings/jasparroos.js';
import reneschoenmakers from './letterfunnel/landings/reneschoenmakers.js';
import machielkunst from './letterfunnel/landings/machielkunst.js';
import tamarnetergans from './letterfunnel/landings/tamarnetergans.js';
import pauldols from './letterfunnel/landings/pauldols.js';
import erwinbeets from './letterfunnel/landings/erwinbeets.js';
import maikovandermeer from './letterfunnel/landings/maikovandermeer.js';
import quincyverkolf from './letterfunnel/landings/quincyverkolf.js';
import martijngroeneweg from './letterfunnel/landings/martijngroeneweg.js';
import paulfrankenhuizen from './letterfunnel/landings/paulfrankenhuizen.js';
import jesseweltevreden from './letterfunnel/landings/jesseweltevreden.js';
import alexanderzandbergen from './letterfunnel/landings/alexanderzandbergen.js';
import stevenbodde from './letterfunnel/landings/stevenbodde.js';
import armandomuis from './letterfunnel/landings/armandomuis.js';
import christiaandesbouvrie from './letterfunnel/landings/christiaandesbouvrie.js';
import serhatsakarya from './letterfunnel/landings/serhatsakarya.js';
import martijnvandijk from './letterfunnel/landings/martijnvandijk.js';
import franziskaschaadt from './letterfunnel/landings/franziskaschaadt.js';
import jeroenvandenhurk from './letterfunnel/landings/jeroenvandenhurk.js';
import janbrolsma from './letterfunnel/landings/janbrolsma.js';
import olivierbaas from './letterfunnel/landings/olivierbaas.js';
import hubertmartens from './letterfunnel/landings/hubertmartens.js';
import dennisschabracq from './letterfunnel/landings/dennisschabracq.js';
import dennisderee from './letterfunnel/landings/dennisderee.js';
import daviddwinger from './letterfunnel/landings/daviddwinger.js';
import chrisobdam from './letterfunnel/landings/chrisobdam.js';
import tinkybart from './letterfunnel/landings/tinkybart.js';
import frisovandebeeten from './letterfunnel/landings/frisovandebeeten.js';
import andreasloizou from './letterfunnel/landings/andreasloizou.js';
import camieldutourgeerling from './letterfunnel/landings/camieldutourgeerling.js';
import leondoorn from './letterfunnel/landings/leondoorn.js';
import koenthijssen from './letterfunnel/landings/koenthijssen.js';
import martinhendricks from './letterfunnel/landings/martinhendricks.js';
import frankvisser from './letterfunnel/landings/frankvisser.js';
import hansscheffer from './letterfunnel/landings/hansscheffer.js';
import petervanee from './letterfunnel/landings/petervanee.js';
import arjendeboer from './letterfunnel/landings/arjendeboer.js';
import sergepoppes from './letterfunnel/landings/sergepoppes.js';
import lottewelten from './letterfunnel/landings/lottewelten.js';
import fransclaus from './letterfunnel/landings/fransclaus.js';
import davidsack from './letterfunnel/landings/davidsack.js';
import stefanvandenberg from './letterfunnel/landings/stefanvandenberg.js';
import jellevisser from './letterfunnel/landings/jellevisser.js';
import jolandakooi from './letterfunnel/landings/jolandakooi.js';
import jasperquak from './letterfunnel/landings/jasperquak.js';
import harikishoresreenivasalu from './letterfunnel/landings/harikishoresreenivasalu.js';
import coertcoomans from './letterfunnel/landings/coertcoomans.js';
import jasperbron from './letterfunnel/landings/jasperbron.js';
import diegosmits from './letterfunnel/landings/diegosmits.js';
import remcovannieuwenhoven from './letterfunnel/landings/remcovannieuwenhoven.js';
import marinatognetti from './letterfunnel/landings/marinatognetti.js';
import vincentvermeulen from './letterfunnel/landings/vincentvermeulen.js';
import frankleest from './letterfunnel/landings/frankleest.js';
import ernstthijsen from './letterfunnel/landings/ernstthijsen.js';
import bibijorissen from './letterfunnel/landings/bibijorissen.js';
import antonvandaal from './letterfunnel/landings/antonvandaal.js';
import jeanjacquesvossen from './letterfunnel/landings/jeanjacquesvossen.js';
import onnovancommene from './letterfunnel/landings/onnovancommene.js';
import liamtjoa from './letterfunnel/landings/liamtjoa.js';
import markremie from './letterfunnel/landings/markremie.js';
import jeroenmerry from './letterfunnel/landings/jeroenmerry.js';
import woltertjeenkwillink from './letterfunnel/landings/woltertjeenkwillink.js';
import lukashietkamp from './letterfunnel/landings/lukashietkamp.js';
import jorisverwater from './letterfunnel/landings/jorisverwater.js';
import koenlooijmans from './letterfunnel/landings/koenlooijmans.js';
import martijnapeldoorn from './letterfunnel/landings/martijnapeldoorn.js';
import jobcouwenberg from './letterfunnel/landings/jobcouwenberg.js';
import diniklaassen from './letterfunnel/landings/diniklaassen.js';
import gerritverwijs from './letterfunnel/landings/gerritverwijs.js';
import sanderklos from './letterfunnel/landings/sanderklos.js';
import jorritvelzeboer from './letterfunnel/landings/jorritvelzeboer.js';
import susanvangeenen from './letterfunnel/landings/susanvangeenen.js';
import harrostokman from './letterfunnel/landings/harrostokman.js';
import jeroenwissink from './letterfunnel/landings/jeroenwissink.js';
import lindafrietman from './letterfunnel/landings/lindafrietman.js';
import merijndewaard from './letterfunnel/landings/merijndewaard.js';
import michaelvanderheijden from './letterfunnel/landings/michaelvanderheijden.js';
import jeanyvescharlier from './letterfunnel/landings/jeanyvescharlier.js';
import nielsjonker from './letterfunnel/landings/nielsjonker.js';
import sjorsgoemans from './letterfunnel/landings/sjorsgoemans.js';
import robertnieuwland from './letterfunnel/landings/robertnieuwland.js';
import dejandujak from './letterfunnel/landings/dejandujak.js';
import justinoud from './letterfunnel/landings/justinoud.js';
import pimvanhelten from './letterfunnel/landings/pimvanhelten.js';
import johannesgergin from './letterfunnel/landings/johannesgergin.js';
import ericburnik from './letterfunnel/landings/ericburnik.js';
import marcelhoogendoorn from './letterfunnel/landings/marcelhoogendoorn.js';
import berriepelser from './letterfunnel/landings/berriepelser.js';
import joostvansuijlekom from './letterfunnel/landings/joostvansuijlekom.js';
import oluseyiakinnibosun from './letterfunnel/landings/oluseyiakinnibosun.js';
import markodobroschelski from './letterfunnel/landings/markodobroschelski.js';
import ericmarkhuitema from './letterfunnel/landings/ericmarkhuitema.js';
import murugeshramachandran from './letterfunnel/landings/murugeshramachandran.js';
import recepbakirci from './letterfunnel/landings/recepbakirci.js';
import martijnsteffers from './letterfunnel/landings/martijnsteffers.js';
import pieterjanpieters from './letterfunnel/landings/pieterjanpieters.js';
import petergerritsen from './letterfunnel/landings/petergerritsen.js';
import robvanstraten from './letterfunnel/landings/robvanstraten.js';
import gianlucadibella from './letterfunnel/landings/gianlucadibella.js';
import jordyonrust from './letterfunnel/landings/jordyonrust.js';
import andymosmans from './letterfunnel/landings/andymosmans.js';
import jaappostma from './letterfunnel/landings/jaappostma.js';
import stefanlemmens from './letterfunnel/landings/stefanlemmens.js';
import emiliyanenevemo from './letterfunnel/landings/emiliyanenevemo.js';
import peterkleinjan from './letterfunnel/landings/peterkleinjan.js';
import nickbos from './letterfunnel/landings/nickbos.js';
import wesleyvanderlinden from './letterfunnel/landings/wesleyvanderlinden.js';
import coertrasenberg from './letterfunnel/landings/coertrasenberg.js';
import aartvangeemert from './letterfunnel/landings/aartvangeemert.js';
import kellyruigrok from './letterfunnel/landings/kellyruigrok.js';
import sanderjellema from './letterfunnel/landings/sanderjellema.js';
import henkluitjes from './letterfunnel/landings/henkluitjes.js';
import roberttinga from './letterfunnel/landings/roberttinga.js';
import merlijndevroe from './letterfunnel/landings/merlijndevroe.js';
import mykytasemenov from './letterfunnel/landings/mykytasemenov.js';
import arunkumar from './letterfunnel/landings/arunkumar.js';
import jelkeschippers from './letterfunnel/landings/jelkeschippers.js';
import insdewit from './letterfunnel/landings/insdewit.js';
import paulsomberg from './letterfunnel/landings/paulsomberg.js';
import pierrebartholomeus from './letterfunnel/landings/pierrebartholomeus.js';
import jorennieuwenhuizen from './letterfunnel/landings/jorennieuwenhuizen.js';
import erikjankerssies from './letterfunnel/landings/erikjankerssies.js';
import bastiaanvanhamersveld from './letterfunnel/landings/bastiaanvanhamersveld.js';
import carlobogerd from './letterfunnel/landings/carlobogerd.js';

import renealtena from './letterfunnel/landings/renealtena.js';
import andrewkillen from './letterfunnel/landings/andrewkillen.js';
import derkvanderwoude from './letterfunnel/landings/derkvanderwoude.js';
import christiaanmolendijk from './letterfunnel/landings/christiaanmolendijk.js';
import robinvanruitenbeek from './letterfunnel/landings/robinvanruitenbeek.js';
import michielvanoudheusden from './letterfunnel/landings/michielvanoudheusden.js';
import peterchaianov from './letterfunnel/landings/peterchaianov.js';
import thieryketz from './letterfunnel/landings/thieryketz.js';
import petergiskes from './letterfunnel/landings/petergiskes.js';
import jasperschulte from './letterfunnel/landings/jasperschulte.js';
import pieterdegraaf from './letterfunnel/landings/pieterdegraaf.js';
import pragneshgandhi from './letterfunnel/landings/pragneshgandhi.js';
import alexverstappen from './letterfunnel/landings/alexverstappen.js';
import klaasfoppen from './letterfunnel/landings/klaasfoppen.js';
import thierrydereus from './letterfunnel/landings/thierrydereus.js';
import davidconde from './letterfunnel/landings/davidconde.js';
import rachiddegraaff from './letterfunnel/landings/rachiddegraaff.js';
import nielsdeblaauw from './letterfunnel/landings/nielsdeblaauw.js';
import thomashelbo from './letterfunnel/landings/thomashelbo.js';
import gordonsmit from './letterfunnel/landings/gordonsmit.js';
import mennojongerius from './letterfunnel/landings/mennojongerius.js';
import alexmavrishchev from './letterfunnel/landings/alexmavrishchev.js';
import bartelverkruijssen from './letterfunnel/landings/bartelverkruijssen.js';
import maartenvervoorn from './letterfunnel/landings/maartenvervoorn.js';
import samuelkaluvuri from './letterfunnel/landings/samuelkaluvuri.js';
import brammittendorff from './letterfunnel/landings/brammittendorff.js';
import kristianschmidt from './letterfunnel/landings/kristianschmidt.js';
import jeroenvanwinden from './letterfunnel/landings/jeroenvanwinden.js';
import wesleypeeters from './letterfunnel/landings/wesleypeeters.js';
import ronnievisser from './letterfunnel/landings/ronnievisser.js';
import santiagoaragon from './letterfunnel/landings/santiagoaragon.js';
import jorisconijn from './letterfunnel/landings/jorisconijn.js';
import dennisvandenende from './letterfunnel/landings/dennisvandenende.js';
import doekeleeuwis from './letterfunnel/landings/doekeleeuwis.js';
import jaaphaagmans from './letterfunnel/landings/jaaphaagmans.js';
import fidovandenbos from './letterfunnel/landings/fidovandenbos.js';
import andresampaio from './letterfunnel/landings/andresampaio.js';
import charlesbeaumont from './letterfunnel/landings/charlesbeaumont.js';
import janwillemdebirk from './letterfunnel/landings/janwillemdebirk.js';
import tomassalfischberger from './letterfunnel/landings/tomassalfischberger.js';
import christopherwilson from './letterfunnel/landings/christopherwilson.js';
import thijsvanleeuwen from './letterfunnel/landings/thijsvanleeuwen.js';
import donnyvanderlinde from './letterfunnel/landings/donnyvanderlinde.js';
import weiya from './letterfunnel/landings/weiya.js';
import floristenhove from './letterfunnel/landings/floristenhove.js';
import markmaneschijn from './letterfunnel/landings/markmaneschijn.js';
import joostvunderink from './letterfunnel/landings/joostvunderink.js';
import alessandrobruno from './letterfunnel/landings/alessandrobruno.js';
import pietkerkhofs from './letterfunnel/landings/pietkerkhofs.js';
import samehalfar from './letterfunnel/landings/samehalfar.js';
import erikbaan from './letterfunnel/landings/erikbaan.js';
import jeroenrinzema from './letterfunnel/landings/jeroenrinzema.js';
import marclaros from './letterfunnel/landings/marclaros.js';
import berrylangerak from './letterfunnel/landings/berrylangerak.js';
import mikaeilshaghelani from './letterfunnel/landings/mikaeilshaghelani.js';
import thomasberrens from './letterfunnel/landings/thomasberrens.js';
import luistelo from './letterfunnel/landings/luistelo.js';
import diegonijboer from './letterfunnel/landings/diegonijboer.js';
import marcelhageman from './letterfunnel/landings/marcelhageman.js';
import jorgenhorstink from './letterfunnel/landings/jorgenhorstink.js';

import redir_li from './redir_li.js'
import redir_gmb from './redir_gmb.js'
import redir_testimonials from './redir_testimonials.js'
import redir_scorecard from './redir_scorecard.js'
import redir_diagnose from './redir_diagnose.js'

import PageNotFound from 'Skelet/src/components/PageNotFound';
import StartRoute from './route-containers/StartRoute';


class App extends React.Component {

  render() {
    return (
      <div id="main">
        <Switch>
          <StartRoute exact path="/" component={Start} />

          <Route exact path="/reviews" component={redir_testimonials} />
          <StartRoute exact path="/testimonials" component={Reviews} />

          <StartRoute exact path="/gratis" component={LeadMagnets} />

          <StartRoute exact path="/diensten" component={Services} />

          <StartRoute exact path="/diensten/berichten" component={ServicesPosts} />

          <StartRoute exact path="/diensten/artikelen" component={ServicesArticles} />

          <StartRoute exact path="/eenmalige-diensten" component={OneOff} />

          <StartRoute exact path="/portfolio" component={Portfolio} />

          <StartRoute exact path="/contact" component={Contact} />

          <StartRoute exact path="/brief-generator" component={LetterGenerator} hideheader="true" />
          <StartRoute exact path="/brief-generator-cto" component={LetterGeneratorCTO} hideheader="true" />

          <StartRoute exact path="/pagina-generator" component={PageGenerator} hideheader="true" />
          <StartRoute exact path="/pagina-generator-cto" component={PageGeneratorCTO} hideheader="true" />

          <StartRoute exact path="/artikelen" component={Articles} />

          <StartRoute exact path="/duizenden-euros-coaching-maar-de-eerste-sessie-overgeslagen" component={Article1} />
          <StartRoute exact path="/een-uitgebreide-samenvatting-van-honderden-profiel-analyses" component={Article2} />
          <StartRoute exact path="/consistent-schrijven-hoe-kun-jij-iedere-week-berichten-plaatsen-op-linkedin" component={Article3} />
          <StartRoute exact path="/de-executives-gids-voor-linkedin-ghostwriting-hoe-jij-jouw-personal-brand-kunt-opschalen" component={Article4} />

          <StartRoute exact path="/brieftest123" component={LetterLandingExample} hideheader="true" />
          <StartRoute exact path="/brieftest456" component={LetterLandingExampleCTO} hideheader="true" />

          <StartRoute exact path="/jeffreyhamelink" component={jeffreyhamelink} hideheader="true" />
          <StartRoute exact path="/peterharmschalk" component={peterharmschalk} hideheader="true" />
          <StartRoute exact path="/dennisnieuwenhuys" component={dennisnieuwenhuys} hideheader="true" />
          <StartRoute exact path="/peterpauldevries" component={peterpauldevries} hideheader="true" />
          <StartRoute exact path="/wanglongli" component={wanglongli} hideheader="true" />
          <StartRoute exact path="/paulbuyse" component={paulbuyse} hideheader="true" />
          <StartRoute exact path="/ralphbrasker" component={ralphbrasker} hideheader="true" />
          <StartRoute exact path="/leanschieving" component={leanschieving} hideheader="true" />
          <StartRoute exact path="/marielschaab" component={marielschaab} hideheader="true" />
          <StartRoute exact path="/albertkuiper" component={albertkuiper} hideheader="true" />
          <StartRoute exact path="/bertholdbakker" component={bertholdbakker} hideheader="true" />
          <StartRoute exact path="/laurensvanmierlo" component={laurensvanmierlo} hideheader="true" />
          <StartRoute exact path="/marcodeboer" component={marcodeboer} hideheader="true" />
          <StartRoute exact path="/ericschouten" component={ericschouten} hideheader="true" />
          <StartRoute exact path="/mariekevaniperen" component={mariekevaniperen} hideheader="true" />
          <StartRoute exact path="/gerritjanreinders" component={gerritjanreinders} hideheader="true" />
          <StartRoute exact path="/robinschuil" component={robinschuil} hideheader="true" />
          <StartRoute exact path="/tomkamperman" component={tomkamperman} hideheader="true" />
          <StartRoute exact path="/joachimdelooij" component={joachimdelooij} hideheader="true" />
          <StartRoute exact path="/arnoknoops" component={arnoknoops} hideheader="true" />
          <StartRoute exact path="/laurensgroen" component={laurensgroen} hideheader="true" />
          <StartRoute exact path="/renaldomelkert" component={renaldomelkert} hideheader="true" />
          <StartRoute exact path="/joachimbeckmann" component={joachimbeckmann} hideheader="true" />
          <StartRoute exact path="/tonychung" component={tonychung} hideheader="true" />
          <StartRoute exact path="/joslazet" component={joslazet} hideheader="true" />
          <StartRoute exact path="/ashokmarla" component={ashokmarla} hideheader="true" />
          <StartRoute exact path="/jaapdebruijn" component={jaapdebruijn} hideheader="true" />
          <StartRoute exact path="/jochananbax" component={jochananbax} hideheader="true" />
          <StartRoute exact path="/markvanwerven" component={markvanwerven} hideheader="true" />
          <StartRoute exact path="/brunopellicci" component={brunopellicci} hideheader="true" />
          <StartRoute exact path="/janjaapvandenhoek" component={janjaapvandenhoek} hideheader="true" />
          <StartRoute exact path="/remcotreuren" component={remcotreuren} hideheader="true" />
          <StartRoute exact path="/dirkhuibers" component={dirkhuibers} hideheader="true" />
          <StartRoute exact path="/gijsopdeweegh" component={gijsopdeweegh} hideheader="true" />
          <StartRoute exact path="/wannepemmelaar" component={wannepemmelaar} hideheader="true" />
          <StartRoute exact path="/nickblom" component={nickblom} hideheader="true" />
          <StartRoute exact path="/meesvanvelzen" component={meesvanvelzen} hideheader="true" />
          <StartRoute exact path="/koenlavrijssen" component={koenlavrijssen} hideheader="true" />
          <StartRoute exact path="/rubenwieman" component={rubenwieman} hideheader="true" />
          <StartRoute exact path="/nickhillebrand" component={nickhillebrand} hideheader="true" />
          <StartRoute exact path="/janwillemseeder" component={janwillemseeder} hideheader="true" />
          <StartRoute exact path="/edwinvlieg" component={edwinvlieg} hideheader="true" />
          <StartRoute exact path="/fionagu" component={fionagu} hideheader="true" />
          <StartRoute exact path="/bobsalm" component={bobsalm} hideheader="true" />
          <StartRoute exact path="/johankenzeler" component={johankenzeler} hideheader="true" />
          <StartRoute exact path="/christopherhoffman" component={christopherhoffman} hideheader="true" />
          <StartRoute exact path="/otmannouinou" component={otmannouinou} hideheader="true" />
          <StartRoute exact path="/eduardanghel" component={eduardanghel} hideheader="true" />
          <StartRoute exact path="/ankievanwersch" component={ankievanwersch} hideheader="true" />
          <StartRoute exact path="/rupeshkumar" component={rupeshkumar} hideheader="true" />
          <StartRoute exact path="/jennifergoodall" component={jennifergoodall} hideheader="true" />
          <StartRoute exact path="/susantmallick" component={susantmallick} hideheader="true" />
          <StartRoute exact path="/robvandenhoogen" component={robvandenhoogen} hideheader="true" />
          <StartRoute exact path="/jasparroos" component={jasparroos} hideheader="true" />
          <StartRoute exact path="/reneschoenmakers" component={reneschoenmakers} hideheader="true" />
          <StartRoute exact path="/machielkunst" component={machielkunst} hideheader="true" />
          <StartRoute exact path="/tamarnetergans" component={tamarnetergans} hideheader="true" />
          <StartRoute exact path="/pauldols" component={pauldols} hideheader="true" />
          <StartRoute exact path="/erwinbeets" component={erwinbeets} hideheader="true" />
          <StartRoute exact path="/maikovandermeer" component={maikovandermeer} hideheader="true" />
          <StartRoute exact path="/quincyverkolf" component={quincyverkolf} hideheader="true" />
          <StartRoute exact path="/martijngroeneweg" component={martijngroeneweg} hideheader="true" />
          <StartRoute exact path="/paulfrankenhuizen" component={paulfrankenhuizen} hideheader="true" />
          <StartRoute exact path="/jesseweltevreden" component={jesseweltevreden} hideheader="true" />
          <StartRoute exact path="/alexanderzandbergen" component={alexanderzandbergen} hideheader="true" />
          <StartRoute exact path="/stevenbodde" component={stevenbodde} hideheader="true" />
          <StartRoute exact path="/armandomuis" component={armandomuis} hideheader="true" />
          <StartRoute exact path="/christiaandesbouvrie" component={christiaandesbouvrie} hideheader="true" />
          <StartRoute exact path="/serhatsakarya" component={serhatsakarya} hideheader="true" />
          <StartRoute exact path="/martijnvandijk" component={martijnvandijk} hideheader="true" />
          <StartRoute exact path="/franziskaschaadt" component={franziskaschaadt} hideheader="true" />
          <StartRoute exact path="/jeroenvandenhurk" component={jeroenvandenhurk} hideheader="true" />
          <StartRoute exact path="/janbrolsma" component={janbrolsma} hideheader="true" />
          <StartRoute exact path="/olivierbaas" component={olivierbaas} hideheader="true" />
          <StartRoute exact path="/hubertmartens" component={hubertmartens} hideheader="true" />
          <StartRoute exact path="/dennisschabracq" component={dennisschabracq} hideheader="true" />
          <StartRoute exact path="/dennisderee" component={dennisderee} hideheader="true" />
          <StartRoute exact path="/daviddwinger" component={daviddwinger} hideheader="true" />
          <StartRoute exact path="/chrisobdam" component={chrisobdam} hideheader="true" />
          <StartRoute exact path="/tinkybart" component={tinkybart} hideheader="true" />
          <StartRoute exact path="/frisovandebeeten" component={frisovandebeeten} hideheader="true" />
          <StartRoute exact path="/andreasloizou" component={andreasloizou} hideheader="true" />
          <StartRoute exact path="/camieldutourgeerling" component={camieldutourgeerling} hideheader="true" />
          <StartRoute exact path="/leondoorn" component={leondoorn} hideheader="true" />
          <StartRoute exact path="/koenthijssen" component={koenthijssen} hideheader="true" />
          <StartRoute exact path="/martinhendricks" component={martinhendricks} hideheader="true" />
          <StartRoute exact path="/frankvisser" component={frankvisser} hideheader="true" />
          <StartRoute exact path="/hansscheffer" component={hansscheffer} hideheader="true" />
          <StartRoute exact path="/petervanee" component={petervanee} hideheader="true" />
          <StartRoute exact path="/arjendeboer" component={arjendeboer} hideheader="true" />
          <StartRoute exact path="/sergepoppes" component={sergepoppes} hideheader="true" />
          <StartRoute exact path="/lottewelten" component={lottewelten} hideheader="true" />
          <StartRoute exact path="/fransclaus" component={fransclaus} hideheader="true" />
          <StartRoute exact path="/davidsack" component={davidsack} hideheader="true" />
          <StartRoute exact path="/stefanvandenberg" component={stefanvandenberg} hideheader="true" />
          <StartRoute exact path="/jellevisser" component={jellevisser} hideheader="true" />
          <StartRoute exact path="/jolandakooi" component={jolandakooi} hideheader="true" />
          <StartRoute exact path="/jasperquak" component={jasperquak} hideheader="true" />
          <StartRoute exact path="/harikishoresreenivasalu" component={harikishoresreenivasalu} hideheader="true" />
          <StartRoute exact path="/coertcoomans" component={coertcoomans} hideheader="true" />
          <StartRoute exact path="/jasperbron" component={jasperbron} hideheader="true" />
          <StartRoute exact path="/diegosmits" component={diegosmits} hideheader="true" />
          <StartRoute exact path="/remcovannieuwenhoven" component={remcovannieuwenhoven} hideheader="true" />
          <StartRoute exact path="/marinatognetti" component={marinatognetti} hideheader="true" />
          <StartRoute exact path="/vincentvermeulen" component={vincentvermeulen} hideheader="true" />
          <StartRoute exact path="/frankleest" component={frankleest} hideheader="true" />
          <StartRoute exact path="/ernstthijsen" component={ernstthijsen} hideheader="true" />
          <StartRoute exact path="/bibijorissen" component={bibijorissen} hideheader="true" />
          <StartRoute exact path="/antonvandaal" component={antonvandaal} hideheader="true" />
          <StartRoute exact path="/jeanjacquesvossen" component={jeanjacquesvossen} hideheader="true" />
          <StartRoute exact path="/onnovancommene" component={onnovancommene} hideheader="true" />
          <StartRoute exact path="/liamtjoa" component={liamtjoa} hideheader="true" />
          <StartRoute exact path="/markremie" component={markremie} hideheader="true" />
          <StartRoute exact path="/jeroenmerry" component={jeroenmerry} hideheader="true" />
          <StartRoute exact path="/woltertjeenkwillink" component={woltertjeenkwillink} hideheader="true" />
          <StartRoute exact path="/lukashietkamp" component={lukashietkamp} hideheader="true" />
          <StartRoute exact path="/jorisverwater" component={jorisverwater} hideheader="true" />
          <StartRoute exact path="/koenlooijmans" component={koenlooijmans} hideheader="true" />
          <StartRoute exact path="/martijnapeldoorn" component={martijnapeldoorn} hideheader="true" />
          <StartRoute exact path="/jobcouwenberg" component={jobcouwenberg} hideheader="true" />
          <StartRoute exact path="/diniklaassen" component={diniklaassen} hideheader="true" />
          <StartRoute exact path="/gerritverwijs" component={gerritverwijs} hideheader="true" />
          <StartRoute exact path="/sanderklos" component={sanderklos} hideheader="true" />
          <StartRoute exact path="/jorritvelzeboer" component={jorritvelzeboer} hideheader="true" />
          <StartRoute exact path="/susanvangeenen" component={susanvangeenen} hideheader="true" />
          <StartRoute exact path="/harrostokman" component={harrostokman} hideheader="true" />
          <StartRoute exact path="/jeroenwissink" component={jeroenwissink} hideheader="true" />
          <StartRoute exact path="/lindafrietman" component={lindafrietman} hideheader="true" />
          <StartRoute exact path="/merijndewaard" component={merijndewaard} hideheader="true" />
          <StartRoute exact path="/michaelvanderheijden" component={michaelvanderheijden} hideheader="true" />
          <StartRoute exact path="/jeanyvescharlier" component={jeanyvescharlier} hideheader="true" />
          <StartRoute exact path="/nielsjonker" component={nielsjonker} hideheader="true" />
          <StartRoute exact path="/sjorsgoemans" component={sjorsgoemans} hideheader="true" />
          <StartRoute exact path="/robertnieuwland" component={robertnieuwland} hideheader="true" />
          <StartRoute exact path="/dejandujak" component={dejandujak} hideheader="true" />
          <StartRoute exact path="/justinoud" component={justinoud} hideheader="true" />
          <StartRoute exact path="/pimvanhelten" component={pimvanhelten} hideheader="true" />
          <StartRoute exact path="/johannesgergin" component={johannesgergin} hideheader="true" />
          <StartRoute exact path="/ericburnik" component={ericburnik} hideheader="true" />
          <StartRoute exact path="/marcelhoogendoorn" component={marcelhoogendoorn} hideheader="true" />
          <StartRoute exact path="/berriepelser" component={berriepelser} hideheader="true" />
          <StartRoute exact path="/joostvansuijlekom" component={joostvansuijlekom} hideheader="true" />
          <StartRoute exact path="/oluseyiakinnibosun" component={oluseyiakinnibosun} hideheader="true" />
          <StartRoute exact path="/markodobroschelski" component={markodobroschelski} hideheader="true" />
          <StartRoute exact path="/ericmarkhuitema" component={ericmarkhuitema} hideheader="true" />
          <StartRoute exact path="/murugeshramachandran" component={murugeshramachandran} hideheader="true" />
          <StartRoute exact path="/recepbakirci" component={recepbakirci} hideheader="true" />
          <StartRoute exact path="/martijnsteffers" component={martijnsteffers} hideheader="true" />
          <StartRoute exact path="/pieterjanpieters" component={pieterjanpieters} hideheader="true" />
          <StartRoute exact path="/petergerritsen" component={petergerritsen} hideheader="true" />
          <StartRoute exact path="/robvanstraten" component={robvanstraten} hideheader="true" />
          <StartRoute exact path="/gianlucadibella" component={gianlucadibella} hideheader="true" />
          <StartRoute exact path="/jordyonrust" component={jordyonrust} hideheader="true" />
          <StartRoute exact path="/andymosmans" component={andymosmans} hideheader="true" />
          <StartRoute exact path="/jaappostma" component={jaappostma} hideheader="true" />
          <StartRoute exact path="/stefanlemmens" component={stefanlemmens} hideheader="true" />
          <StartRoute exact path="/emiliyanenevemo" component={emiliyanenevemo} hideheader="true" />
          <StartRoute exact path="/peterkleinjan" component={peterkleinjan} hideheader="true" />
          <StartRoute exact path="/nickbos" component={nickbos} hideheader="true" />
          <StartRoute exact path="/wesleyvanderlinden" component={wesleyvanderlinden} hideheader="true" />
          <StartRoute exact path="/coertrasenberg" component={coertrasenberg} hideheader="true" />
          <StartRoute exact path="/aartvangeemert" component={aartvangeemert} hideheader="true" />
          <StartRoute exact path="/kellyruigrok" component={kellyruigrok} hideheader="true" />
          <StartRoute exact path="/sanderjellema" component={sanderjellema} hideheader="true" />
          <StartRoute exact path="/henkluitjes" component={henkluitjes} hideheader="true" />
          <StartRoute exact path="/roberttinga" component={roberttinga} hideheader="true" />
          <StartRoute exact path="/merlijndevroe" component={merlijndevroe} hideheader="true" />
          <StartRoute exact path="/mykytasemenov" component={mykytasemenov} hideheader="true" />
          <StartRoute exact path="/arunkumar" component={arunkumar} hideheader="true" />
          <StartRoute exact path="/jelkeschippers" component={jelkeschippers} hideheader="true" />
          <StartRoute exact path="/insdewit" component={insdewit} hideheader="true" />
          <StartRoute exact path="/paulsomberg" component={paulsomberg} hideheader="true" />
          <StartRoute exact path="/pierrebartholomeus" component={pierrebartholomeus} hideheader="true" />
          <StartRoute exact path="/jorennieuwenhuizen" component={jorennieuwenhuizen} hideheader="true" />
          <StartRoute exact path="/erikjankerssies" component={erikjankerssies} hideheader="true" />
          <StartRoute exact path="/bastiaanvanhamersveld" component={bastiaanvanhamersveld} hideheader="true" />
          <StartRoute exact path="/carlobogerd" component={carlobogerd} hideheader="true" />

          <StartRoute exact path="/renealtena" component={renealtena} hideheader="true" />
          <StartRoute exact path="/andrewkillen" component={andrewkillen} hideheader="true" />
          <StartRoute exact path="/derkvanderwoude" component={derkvanderwoude} hideheader="true" />
          <StartRoute exact path="/christiaanmolendijk" component={christiaanmolendijk} hideheader="true" />
          <StartRoute exact path="/robinvanruitenbeek" component={robinvanruitenbeek} hideheader="true" />
          <StartRoute exact path="/michielvanoudheusden" component={michielvanoudheusden} hideheader="true" />
          <StartRoute exact path="/peterchaianov" component={peterchaianov} hideheader="true" />
          <StartRoute exact path="/thieryketz" component={thieryketz} hideheader="true" />
          <StartRoute exact path="/petergiskes" component={petergiskes} hideheader="true" />
          <StartRoute exact path="/jasperschulte" component={jasperschulte} hideheader="true" />
          <StartRoute exact path="/pieterdegraaf" component={pieterdegraaf} hideheader="true" />
          <StartRoute exact path="/pragneshgandhi" component={pragneshgandhi} hideheader="true" />
          <StartRoute exact path="/alexverstappen" component={alexverstappen} hideheader="true" />
          <StartRoute exact path="/klaasfoppen" component={klaasfoppen} hideheader="true" />
          <StartRoute exact path="/thierrydereus" component={thierrydereus} hideheader="true" />
          <StartRoute exact path="/davidconde" component={davidconde} hideheader="true" />
          <StartRoute exact path="/rachiddegraaff" component={rachiddegraaff} hideheader="true" />
          <StartRoute exact path="/nielsdeblaauw" component={nielsdeblaauw} hideheader="true" />
          <StartRoute exact path="/thomashelbo" component={thomashelbo} hideheader="true" />
          <StartRoute exact path="/gordonsmit" component={gordonsmit} hideheader="true" />
          <StartRoute exact path="/mennojongerius" component={mennojongerius} hideheader="true" />
          <StartRoute exact path="/alexmavrishchev" component={alexmavrishchev} hideheader="true" />
          <StartRoute exact path="/bartelverkruijssen" component={bartelverkruijssen} hideheader="true" />
          <StartRoute exact path="/maartenvervoorn" component={maartenvervoorn} hideheader="true" />
          <StartRoute exact path="/samuelkaluvuri" component={samuelkaluvuri} hideheader="true" />
          <StartRoute exact path="/brammittendorff" component={brammittendorff} hideheader="true" />
          <StartRoute exact path="/kristianschmidt" component={kristianschmidt} hideheader="true" />
          <StartRoute exact path="/jeroenvanwinden" component={jeroenvanwinden} hideheader="true" />
          <StartRoute exact path="/wesleypeeters" component={wesleypeeters} hideheader="true" />
          <StartRoute exact path="/ronnievisser" component={ronnievisser} hideheader="true" />
          <StartRoute exact path="/santiagoaragon" component={santiagoaragon} hideheader="true" />
          <StartRoute exact path="/jorisconijn" component={jorisconijn} hideheader="true" />
          <StartRoute exact path="/dennisvandenende" component={dennisvandenende} hideheader="true" />
          <StartRoute exact path="/doekeleeuwis" component={doekeleeuwis} hideheader="true" />
          <StartRoute exact path="/jaaphaagmans" component={jaaphaagmans} hideheader="true" />
          <StartRoute exact path="/fidovandenbos" component={fidovandenbos} hideheader="true" />
          <StartRoute exact path="/andresampaio" component={andresampaio} hideheader="true" />
          <StartRoute exact path="/charlesbeaumont" component={charlesbeaumont} hideheader="true" />
          <StartRoute exact path="/janwillemdebirk" component={janwillemdebirk} hideheader="true" />
          <StartRoute exact path="/tomassalfischberger" component={tomassalfischberger} hideheader="true" />
          <StartRoute exact path="/christopherwilson" component={christopherwilson} hideheader="true" />
          <StartRoute exact path="/thijsvanleeuwen" component={thijsvanleeuwen} hideheader="true" />
          <StartRoute exact path="/donnyvanderlinde" component={donnyvanderlinde} hideheader="true" />
          <StartRoute exact path="/weiya" component={weiya} hideheader="true" />
          <StartRoute exact path="/floristenhove" component={floristenhove} hideheader="true" />
          <StartRoute exact path="/markmaneschijn" component={markmaneschijn} hideheader="true" />
          <StartRoute exact path="/joostvunderink" component={joostvunderink} hideheader="true" />
          <StartRoute exact path="/alessandrobruno" component={alessandrobruno} hideheader="true" />
          <StartRoute exact path="/pietkerkhofs" component={pietkerkhofs} hideheader="true" />
          <StartRoute exact path="/samehalfar" component={samehalfar} hideheader="true" />
          <StartRoute exact path="/erikbaan" component={erikbaan} hideheader="true" />
          <StartRoute exact path="/jeroenrinzema" component={jeroenrinzema} hideheader="true" />
          <StartRoute exact path="/marclaros" component={marclaros} hideheader="true" />
          <StartRoute exact path="/berrylangerak" component={berrylangerak} hideheader="true" />
          <StartRoute exact path="/mikaeilshaghelani" component={mikaeilshaghelani} hideheader="true" />
          <StartRoute exact path="/thomasberrens" component={thomasberrens} hideheader="true" />
          <StartRoute exact path="/luistelo" component={luistelo} hideheader="true" />
          <StartRoute exact path="/diegonijboer" component={diegonijboer} hideheader="true" />
          <StartRoute exact path="/marcelhageman" component={marcelhageman} hideheader="true" />
          <StartRoute exact path="/jorgenhorstink" component={jorgenhorstink} hideheader="true" />

          <Route exact path="/linkedin" component={redir_li} />
          <Route exact path="/review" component={redir_gmb} />
          <Route exact path="/nieuwe-review" component={redir_gmb} />
          <Route exact path="/checklist" component={redir_scorecard} />
          <Route exact path="/diagnose" component={redir_diagnose} />

          <Route
            path="*"
            render={(routeProps) => (
              <PageNotFound website="Ghostin.nl" {...routeProps} />
            )}
          />
        </Switch>
        <AlertBar alert={this.props.alert} clearAlert={this.props.clearAlert} />
      </div>
    );
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    state_router: state.router, // needed for redirect after login
    session_token: session_token,
    redirectUrl: state.apiData.redirectUrl,
    alert: state.apiData.alert,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    push,
    clearAlert,
    clearState,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/_app.js